export default __webpack_public_path__ + "locales/sq-AL/RoomLogoCover.json?hash=fd008923bfe4c89f88093dd2bdf4be90";